<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Skjutreglage
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Används i Degkalkylatorn för att justera hydrering, salt, jäst och övriga
      procentuella värden. Teal fill visar det valda intervallet; grå del är ej
      valt.
    </p>

    <PreviewFull label="Live-reglage — prova att dra!">
      <div class="flex flex-col gap-6">
        <!-- Hydration -->
        <div>
          <div class="flex justify-between mb-1.5">
            <span
              class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] tracking-[0.8px] uppercase"
              >Hydrering</span
            >
            <span class="font-[Poppins] font-bold text-[15px] text-teal-500"
              >{{ hydration }}%</span
            >
          </div>
          <input
            v-model="hydration"
            type="range"
            min="45"
            max="100"
            step="1"
            class="w-full h-1.5 rounded-full appearance-none cursor-pointer outline-none"
            :style="{
              background: `linear-gradient(to right, #14b8a6 ${hydrationPct}%, #e6e8ea ${hydrationPct}%)`,
            }"
          />
          <div class="flex justify-between mt-1">
            <span class="font-[Plus_Jakarta_Sans] text-[11px] text-[#a0b0ae]"
              >45% (fast deg)</span
            >
            <span class="font-[Plus_Jakarta_Sans] text-[11px] text-[#a0b0ae]"
              >100% (mycket blöt)</span
            >
          </div>
        </div>
        <!-- Salt -->
        <div>
          <div class="flex justify-between mb-1.5">
            <span
              class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] tracking-[0.8px] uppercase"
              >Salt</span
            >
            <span class="font-[Poppins] font-bold text-[15px] text-teal-500"
              >{{ Number(salt).toFixed(1) }}%</span
            >
          </div>
          <input
            v-model="salt"
            type="range"
            min="0.5"
            max="3"
            step="0.1"
            class="w-full h-1.5 rounded-full appearance-none cursor-pointer outline-none"
            :style="{
              background: `linear-gradient(to right, #14b8a6 ${saltPct}%, #e6e8ea ${saltPct}%)`,
            }"
          />
          <div class="flex justify-between mt-1">
            <span class="font-[Plus_Jakarta_Sans] text-[11px] text-[#a0b0ae]"
              >0.5%</span
            >
            <span class="font-[Plus_Jakarta_Sans] text-[11px] text-[#a0b0ae]"
              >3.0%</span
            >
          </div>
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<input
  v-model="hydration"
  type="range" min="45" max="100" step="1"
  class="w-full h-1.5 rounded-full appearance-none cursor-pointer outline-none"
  :style="{ background: \`linear-gradient(to right, #14b8a6 \${pct}%, #e6e8ea \${pct}%)\` }"
/>`;
const cssCode = `/* Slider-spår */
-webkit-appearance: none;
appearance: none;
width: 100%;
height: 6px;            /* h-1.5 */
border-radius: 9999px;  /* rounded-full */
outline: none;

/* Track fill (dynamiskt via :style-binding) */
background: linear-gradient(to right, #14b8a6 70%, #e6e8ea 70%);

/* Värde-label */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 15px;
color: #14b8a6;  /* text-teal-500 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const hydration = ref(70);
const salt = ref(2.0);

const hydrationPct = computed(
  () => ((hydration.value - 45) / (100 - 45)) * 100,
);
const saltPct = computed(() => ((salt.value - 0.5) / (3 - 0.5)) * 100);
</script>
